export const getUserACLs = function() {
	let acls = localStorage.getItem('useracls')
	if(acls === '') return false
	return JSON.parse(acls)
}

export const setUserACLs = function(newacls) {
	localStorage.setItem('useracls', JSON.stringify(newacls))
	return true
}

export const unsetUserACLs = function() {
	localStorage.removeItem('useracls')
	return true
}

